import api from '../service/api';
import env from '../env/env';
import utils from '../scripts/utils';

const REQUIRED = "required";
const contract = {
    miniAppName: REQUIRED,
    miniAppId: REQUIRED,
    operationType: REQUIRED,
    platform: REQUIRED,
    userName: REQUIRED,
    operationAmount: "optional"
};

const logAction = (jsonObj, callback) => {

    validateRequestContract(jsonObj, contract);
    const body = utils.fromJsonToString(jsonObj);
    const headers = {
        headers: {
            'client_id': env.APP_CLIENT_ID,
            'Content-Type': 'application/json'
        }
    };

    api.post('miniapps/log', body, headers).then((data) => {
        console.log(data);
        callback();
    }).catch((error) => {
        console.log(error);
        callback();
    });
}

const validateRequestContract = (jsonObj, contract) => {
    for (let property in contract) {
        if (!jsonObj[property] && contract[property] === REQUIRED) {
            console.log("ContractException: " + property + " is required to perform request");
        }
    }
}

const formatAnalyticsData = (platform, miniappName, miniAppId, userName, operationType, operationAmount) => {
    let jsonObj = {
        miniAppId: miniAppId,
        miniAppName: miniappName,
        platform: platform,
        operationType: operationType,
        userName: userName
    };

    if (operationAmount) {
        jsonObj.operationAmount = operationAmount;
    }
    return jsonObj;
}

export default { logAction, formatAnalyticsData };